import *  as React from 'react';
import { useAtom, atom } from 'jotai';

const wallImg = 'Unity/Wall-Finish/Wall-Exposed_Brick.png';
const floorImg = 'Unity/Flooring/Floor-Chevron.png';
const basecabImg = 'Unity/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Base-Cabs-Deluxe-Supermatt-Bordeaux.png';
const wallcabImg = 'Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Wall-Cabs-Deluxe-Supermatt-Bordeaux.png';
const worktopImg = 'Unity/Worksurfaces/Worksurface-Brilliant_White.png';
const handleimg = 'Unity/Handles/No_Handle.png';


export const sceneAtom = atom<{ [index: string]: string | string[] }>({
    "Wall Finish": [wallImg],
    "Flooring Style": [floorImg],
    "Base Cabinet Fronts": [basecabImg],
    "Wall Cabinet Fronts": [wallcabImg],
    "Worktop": [worktopImg],
    "Handle Options": [handleimg],
});

export const imgMove = atom(false);


export const currentUrl = atom({
    baseCabs: '',
    wallCabs: '',
    workSurface: '',
    handles: '',
    floor: '',
    wall: '',
});

export const selectedName = atom(["Bordeaux", "Bordeaux", "Brillaint White", "No Handle"])